export default __webpack_public_path__ + "static/pixta_29486102_HD_1080-68ac1711de4087431deaa7981d04ce34.mp4";